<template>
  <v-dialog
    ref="dialog"
    v-model="menu"
    :return-value.sync="date"
    persistent
    width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        class="custom-datepicker"
        :placeholder="placeholder"
        v-model="dateRangeText"
        readonly
        v-bind="attrs"
        v-on="on"
        outlined
        :rules="rule"
      ></v-text-field>
    </template>
    <v-date-picker v-model="date" scrollable :min="disabledBefore">
      <v-spacer></v-spacer>
      <v-btn text color="primary" @click="menu = false"> {{$vuetify.lang.t('$vuetify.DatepickerCustom.btnCancel')}}</v-btn>
      <v-btn text color="primary" @click="clickOk()"> {{$vuetify.lang.t('$vuetify.DatepickerCustom.btnOk')}}</v-btn>
    </v-date-picker>
  </v-dialog>
</template>
<script>
export default {
    name: 'CustomDatePicker',
    props: {
        value: String,
        placeholder: String,
        rule: Array,
        disabledDateFrom: String
    },
    data: function () {
        return {
            menu: false,
            modal: false,
            date: null,
            disabledBefore: null
        }
    },
    watch: {
        value: function (newItem) {
            this.date = newItem
        },
        disabledDateFrom: function (value) {
            if (value) {
                this.disabledBefore = value + ' 00:00:00'
            }
        }
    },
    computed: {
        dateRangeText: function () {
            return this.formatDate(this.date)
        }
    },
    created: function () {
        this.date = this.value
        if (this.disabledDateFrom) {
            this.disabledBefore = this.disabledDateFrom + ' 00:00:00'
        }
    },
    methods: {
        clickOk: function () {
            this.$refs.dialog.save(this.date)
            this.$emit('input', this.date)
            this.$emit('onChangeDate', this.date)
        },
        formatDate: function (date) {
            if (!date) return null
            const [year, month, day] = date.split('-')
            return `${day}/${month}/${parseInt(year) + 543}`
        }
    }
}
</script>
